import { CoordinatorService } from "./coordinator.service"
import { User } from "./user"

export class UserTag {
    title: string
    isPublic: boolean
    isRequired: boolean

    constructor(private coords: CoordinatorService,
        private _user: User, params: any) {
        this.title = params.tag
        this.isPublic = !!params.isPublic
        this.isRequired = !!params.isRequired
    }


    async setPublicValue(val: boolean) {
        const t = this.title.trim()
        const resp = await this.coords
            .firebase$.callFunction("setPublicUserTag",
                { tag: t, isPublic: val })
        if (resp === "ERROR") return this.isPublic
        this.isPublic = resp.data as boolean
        return this.isPublic
    }

    async delete() {
        if (this.isRequired) return false
        const t = this.title.trim()
        if (!t || this.coords.user$.current !== this._user) return false
        const resp = await this.coords
            .firebase$.callFunction("deleteUserTag", { tag: t })
        if (resp === "ERROR") return false
        if (resp.data) {
            this._user.removeTag(this)
            return true
        } else
            return false
    }
}
